import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
type ButtonProps = {
  children: React.ReactNode;
  className?: string;
  variant?: 'primary' | 'navy' | 'green' | 'outline';
  size?: 'sm' | 'lg';
  arrow?: boolean;
  href?: string;
  target?: '_blank';
  rel?: string;
  onClick?: () => void;
  ariaLabel?: string;
};
export function Button({
  children,
  className = '',
  variant = 'primary',
  size = 'lg',
  arrow = false,
  href,
  target,
  rel,
  onClick,
  ariaLabel
}: ButtonProps) {
  const styles = {
    primary: 'bg-yellow text-navyDeep shadow-[0_10px_26px_rgba(245,197,24,.36)] hover:bg-yellowDark',
    navy: 'bg-navy text-white shadow-[0_10px_26px_rgba(6,23,41,.30)] hover:bg-navyDeep',
    green: 'bg-green text-white shadow-[0_10px_26px_rgba(15,157,88,.32)] hover:bg-greenDark',
    outline: 'border-2 border-yellow bg-transparent text-yellow hover:bg-yellow hover:text-navyDeep'
  };
  const sizes = {
    sm: 'px-4 py-2.5 text-sm',
    lg: 'px-6 py-4 text-sm sm:px-8 sm:text-base'
  };
  const classes = `inline-flex items-center justify-center gap-2 rounded-lg font-extrabold uppercase tracking-wide transition-colors duration-150 ease-out focus:outline-none focus-visible:ring-4 focus-visible:ring-yellow/50 ${styles[variant]} ${sizes[size]} ${className}`;
  if (href) {
    return <a href={href} target={target} rel={rel} className={classes} aria-label={ariaLabel} data-id="element-257" data-mp="omslhwtrxip5">
        {children}
        {arrow && <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-258" data-mp="12m0pd30vtezo" />}
      </a>;
  }
  return <button type="button" onClick={onClick} className={classes} aria-label={ariaLabel} data-id="element-259" data-mp="xnz6ai3ghfo7">
      {children}
      {arrow && <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-260" data-mp="1cfhis5x3ws2t" />}
    </button>;
}